export const ResultType = {
    CHOICE: 'choice',
    TEXT: 'text',
    SCORE: 'score',
    IMAGE: 'image',
    STUDENT_DETAILS: 'studentDetails'
  };
  
  export class HPCLearningOutcome {
    constructor({
      id = null,
      label,
      result = null,
      resultType,
      choices = null
    }) {
      this.id = id;
      this.label = label;
      this.result = result;
      this.resultType = resultType;
      this.choices = choices;
  
      // Validate that choices is provided when resultType is choice
      if (resultType === ResultType.CHOICE && (!choices || choices.length === 0)) {
        throw new Error('Choices must be provided when resultType is choice');
      }
    }
  
    static fromJSON(json) {
      return new HPCLearningOutcome({
        id: json.id,
        label: json.label || '',
        result: json.result,
        resultType: json.resultType || ResultType.TEXT,
        choices: json.choices
      });
    }
  
    toJSON() {
      return {
        id: this.id,
        label: this.label,
        result: this.result,
        resultType: this.resultType,
        choices: this.choices
      };
    }
  }